import React from "react"

import { Box } from "components/common"

import ShippingInfo from "./shipping-info"
import SocialShare from "./social-share"
import WizardActions from "./wizard-actions"
import HeaderDesktop from "./wizard-header/header-desktop"
import WizardOptions from "./wizard-options"

const MainBody = () => (
  <div>
    <HeaderDesktop />
    <WizardOptions />
    <Box
      bg={{ _: "grey.4", tablet: "transparent" }}
      p={{ _: "18px 16px", tablet: "16px 0 0" }}
    >
      <ShippingInfo />
      <WizardActions />
      <SocialShare />
    </Box>
  </div>
)

export default MainBody
